import React from 'react';
import cx from 'classnames';
import styles from './Modal.module.scss';

function ModalHeader(props) {
  const { className, children, ...rest } = props;
  return (
    <header className={cx(styles.modalHeader, className)} {...rest}>
      {children}
    </header>
  );
}

export default ModalHeader;
